export default "__VITE_ASSET__wbJ75$OG__"